import axios from 'axios';

function urlBasePanel(idGrupo) {
  let url = '/lomloe/panel_perfil_salida';
  if (idGrupo) {
    url = `${url}/${idGrupo}`;
  }
  return url;
}

export default {
  info(idGrupo, options) {
    return axios.get(`${urlBasePanel(idGrupo)}/info`, options);
  },
  perfilSalidaAlumno(idGrupo, idAlumno, options) {
    return axios.get(`${urlBasePanel(idGrupo)}/perfil_salida_alumno/${idAlumno}`, options);
  },
  calificacionesAlumno(idGrupo, idAlumno, options) {
    return axios.get(`${urlBasePanel(idGrupo)}/calificaciones_alumno/${idAlumno}`, options);
  },
};
